"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaPart = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const _part_includes_1 = require("../_part_includes");
//@ts-ignore                
let rwsTemplate = T.html `<div class="form-group has-float-label form-group${x => x.required ? ' required' : ''} rounded">
    ${(0, fast_element_1.when)(x => x.label, T.html `<label htmlFor="${x => x.name}" class="" part="label">${x => x.label.t()}</label>`)}
    <textarea 
        part="textarea"
        @change="${(x, c) => x.handleChange(c.event)}" 
        name="${x => x.name}" 
        class="form-control" 
        ?required="${x => x.isRequired}"
        placeholder="${x => x.placeholder ? x.placeholder.t() : ''}"
        rows="${x => x.rows ? x.rows : '3'}"
        cols="${x => x.cols ? x.cols : ''}"
        >${x => x.value}</textarea>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host-context(.force-placeholder) input::placeholder,
select::placeholder,
textarea::placeholder {
  opacity: 1 !important;
}

.form-group.is-invalid label {
  color: var(--error_color) !important;
}
.form-group.is-invalid .form-control {
  border-color: var(--error_color) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !important;
  color: var(--error_color) !important;
}

:host(.no-margin) .form-group {
  margin: 0 !important;
}

:host(.mini) .form-control {
  padding: 0.2rem 0.4rem;
  line-height: 0.8;
  font-size: 0.6rem;
}

:host(.rounded) .form-control {
  border-radius: 0.375rem;
}

.no-label {
  margin-left: 0;
}

.form-group.rounded textarea.form-control {
  resize: vertical;
  min-height: 60px;
  border: 1px solid var(--brand-border, #e4e7ec);
  border-radius: 8px;
  color: var(--ink, #2f2f3a);
  background: #fff;
  font-size: 0.95rem;
  padding: 0.55rem 0.75rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.form-group.rounded textarea.form-control:focus {
  border-color: var(--brand, #17b4a6);
  box-shadow: 0 0 0 0.2rem rgba(23, 180, 166, 0.2);
  outline: none;
}`;
const shadowOptions = { "mode": "open" };
let TextareaPart = class TextareaPart extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.value = '';
        this.ignored = 'false';
        this.dontEmit = false;
        this.handleChange = _part_includes_1.handlePartChange.bind(this);
    }
    requiredChanged(oldValue, newValue) {
        this.required = newValue;
        this.isRequired = this.required === 'true';
    }
    getElement() {
        return this.$('textarea');
    }
    valueChanged(old, newV) {
        if (this.getElement() && old !== newV) {
            this.getElement().value = newV || '';
        }
    }
    reset() {
        this.getElement().value = null;
    }
};
exports.TextareaPart = TextareaPart;
TextareaPart.PART_TYPE = 'textarea';
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "label", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "name", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], TextareaPart.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "placeholder", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "required", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "rows", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "cols", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], TextareaPart.prototype, "ignored", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], TextareaPart.prototype, "dontEmit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], TextareaPart.prototype, "isRequired", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Function)
], TextareaPart.prototype, "onChange", void 0);
exports.TextareaPart = TextareaPart = __decorate([
    (0, client_1.RWSView)('part-textarea', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TextareaPart);
TextareaPart.defineComponent();
